import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_113: FaireProductEntity = {
  token: "starter_collection_113",
  type: "product",
  name: "Cold Brew Can",
  brandName: "Canyon Coffee",
  imageUrl:
    '"https://cdn.faire.com/fastly/1d03a617e618b5fc47dde9d791bb0dcb9ae9286625e0c8a0d2f818a0ec6303bd.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=1324',
  priceDollars: 6,
  msrpDollars: 12,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
